export const HIDE_GOOGLE_MAP = 'HIDE_GOOGLE_MAP';

export function hideGoogleMap() {
    return {
        type: HIDE_GOOGLE_MAP,
    };
}

export default function pointsOfInterest(state = {}, action) {
    switch (action.type) {
        case HIDE_GOOGLE_MAP:
            return {
                ...state,
                hideGoogleMap: true,
            };
        default:
            return state;
    }
}
